module.exports = __webpack_public_path__ + "img/water-quality_attached.9b8e87b1.svg";